import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Typography } from '@material-ui/core';
import BaseButton from '../Buttons/BaseButton';
import TurnstileManagedCaptcha from './TurnstileManagedCaptcha';
import { RecaptchaAction } from '../../Enums/recaptcha';

const TurnstileFallbackOverlay = props => {
  const { open, error, action, onResolved, onError } = props;
  const classes = useStyles();

  if (!open) {
    return <></>;
  }

  let bodyContent;
  if (error) {
    bodyContent = (
      <>
        <Typography className={classes.errorText}>
          No fue posible completar la verificación. Por favor, recarga la página
          e intenta de nuevo.
        </Typography>
        <BaseButton
          className={classes.reloadButton}
          onClick={() => window.location.reload()}
        >
          Recargar página
        </BaseButton>
      </>
    );
  } else {
    bodyContent = (
      <>
        <Typography className={classes.subtitle}>
          Por favor, completa la verificación para continuar.
        </Typography>
        <div className={classes.captchaWrapper}>
          <TurnstileManagedCaptcha
            onResolved={onResolved}
            onError={onError}
            action={action}
            locale="es"
            size="normal"
            theme="light"
          />
        </div>
      </>
    );
  }

  return (
    <div className={classes.overlay}>
      <Paper className={classes.card} elevation={4}>
        <Typography className={classes.title}>
          Verificación de seguridad
        </Typography>
        {bodyContent}
      </Paper>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2100,
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  card: {
    borderRadius: theme.custom.borderRadius,
    padding: theme.spacing(4),
    width: 380,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      width: '90%',
      padding: theme.spacing(3)
    }
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    marginBottom: theme.spacing(1)
  },
  subtitle: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    textAlign: 'center',
    marginBottom: theme.spacing(3)
  },
  captchaWrapper: {
    display: 'flex',
    justifyContent: 'center'
  },
  errorText: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    textAlign: 'center',
    marginBottom: theme.spacing(3)
  },
  reloadButton: {
    marginTop: theme.spacing(1)
  }
}));

TurnstileFallbackOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  action: PropTypes.oneOf(Object.values(RecaptchaAction)),
  onResolved: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired
};

export default TurnstileFallbackOverlay;
